import React from 'react';
import PayrollHistoryFunctional from './components/payroll-history-functional';
import './payroll-status.scss';

const PayrollHistory = () => {
	return <PayrollHistoryFunctional />;
};

export default PayrollHistory;
